module.exports = __webpack_public_path__ + "static/media/trash.b274c16a.png";